const sections = document.querySelectorAll( '.features' );


sections.forEach( section => {
    const slider = section.querySelector( '.flex-row' );
    let cols = slider.dataset.cols;

    // Set a max to display
    if ( cols > 4 ) {
        cols = 4;
    }

    jQuery( slider ).slick( {
        slidesToShow: cols,
        arrows: false,
        autoplay: true,
        autplaySpeed: 3000,
        pauseOnHover: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    } );
} );